module.exports = __webpack_public_path__ + "static/buninoven-140600c129c1e468f5eb776b27605797.jpeg";